export default function Divider({color = "orange"}: {color: string}) {
  const colorClasses = {
    orange: "bg-orange",
    green: "bg-green",
    blue: "bg-blue",
    red: "bg-red",
    purple: "bg-purple",
    teal: "bg-teal",
    white: "bg-white",
    black: "bg-black",
    "dark-blue": "bg-dark-blue",
  };
  return (
    <div className={`divider max-w-[573px] h-[1px] w-full ${colorClasses[color]} my-8`}></div>
  );
}
